module.exports = __webpack_public_path__ + "img/figma.487d345a.svg";